/* Traduce al español los textos fijos en inglés del formulario de pago contra entrega (Releasit). */
(function () {
  var MAPA = {
    'Default rate': 'Envío Estándar a Domicilio',
    'Free': 'Gratis',
    'Apply': 'Aplicar',
    'Discount code': 'Código de descuento',
    'Subtotal': 'Subtotal',
    'Shipping': 'Envío',
    'Discounts': 'Descuentos',
    'Discount': 'Descuento',
    'Direccion de envio': 'Dirección de envío',
    'Metodo de envio': 'Método de envío',
    'Envio': 'Envío'
  };
  var ocupado = false;
  function traducir() {
    var raiz = document.getElementById('rsi_form_wrapper') || document.querySelector('[id^="rsi_"]');
    if (!raiz || ocupado) return;
    ocupado = true;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue.trim();
      if (t && Object.prototype.hasOwnProperty.call(MAPA, t) && MAPA[t] !== t) {
        n.nodeValue = n.nodeValue.replace(t, MAPA[t]);
      }
    }
    /* Precios con punto de miles ($4.990), como en el resto de la tienda. */
    var w2 = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT), m;
    while ((m = w2.nextNode())) {
      if (/\$\s?\d{1,3}(,\d{3})+/.test(m.nodeValue)) {
        m.nodeValue = m.nodeValue.replace(/\$\s?(\d{1,3}(?:,\d{3})+)/g, function (x, num) { return '$' + num.replace(/,/g, '.'); });
      }
    }
    /* Antes de elegir región Releasit muestra una tarifa "Default rate" en $0: no es gratis, se calcula luego. */
    raiz.querySelectorAll('.rsi-shipping-rates-title').forEach(function (e) {
      if (e.textContent.trim() === 'Envío Estándar a Domicilio') {
        var fila = e.closest('label'), p = fila && fila.querySelector('.rsi-shipping-rates-price');
        if (p && fila.querySelector('input').value.indexOf('Default rate') > -1) {
          if (p.textContent !== 'Según tu región') p.textContent = 'Según tu región';
          if (!fila.querySelector('.tc-es-desc')) {
            var d = document.createElement('div');
            d.className = 'tc-es-desc';
            d.style.cssText = 'font-size:12px;opacity:.75;font-weight:400';
            d.textContent = 'Blue Express / Starken';
            e.parentElement.appendChild(d);
          }
        }
      }
    });
    /* Fila "Envío" del resumen: con la tarifa provisoria no es gratis todavía. */
    var prov = raiz.querySelector('input[name="shippingRate"]:checked');
    if (prov && prov.value.indexOf('Default rate') > -1) {
      raiz.querySelectorAll('*').forEach(function (e) {
        if (e.children.length || e.closest('.rsi-shipping-rates-item')) return;
        if (/^Env[ií]o$/.test(e.textContent.trim())) {
          var fila = e.parentElement, v = fila && fila.lastElementChild;
          if (v && v !== e && /^(Gratis|Free)$/.test(v.textContent.trim())) v.textContent = 'Según tu región';
          /* (solo cambia si dice Gratis/Free, así no se vuelve a disparar) */
        }
      });
    }
    raiz.querySelectorAll('[placeholder]').forEach(function (e) {
      if (MAPA[e.placeholder]) e.placeholder = MAPA[e.placeholder];
    });
    ocupado = false;
  }
  var timer;
  var opciones = { childList: true, subtree: true };
  var obs = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      obs.disconnect();           /* no escuchar nuestros propios cambios (evita bucles) */
      traducir();
      obs.takeRecords();
      obs.observe(document.documentElement, opciones);
    }, 80);
  });
  obs.observe(document.documentElement, opciones);
  traducir();
})();
